const SERVICE_WORKER_UPDATE_RE =
    /Failed to (?:update|register) a ServiceWorker/i
const SERVICE_WORKER_SCRIPT_FETCH_RE =
    /ServiceWorker[\s\S]*fetching the script/i
const SW_SCRIPT_FETCH_RE =
    /An unknown error occurred when fetching the script[\s\S]*sw\.js/i
const STALE_CSS_PRELOAD_RE = /Unable to preload CSS/i
const STALE_DYNAMIC_IMPORT_RE = /Failed to fetch dynamically imported module/i

/**
 * Client errors that are usually transient and not actionable app bugs:
 * service worker update failures (offline tab, ad blockers, proxies) and stale
 * asset loads after deploy (old tabs referencing removed hashed /assets/ chunks).
 */
export function isBenignClientError(message: string, stack?: string): boolean {
    const combined = stack ? `${message}\n${stack}` : message

    return (
        SERVICE_WORKER_UPDATE_RE.test(combined)
        || SERVICE_WORKER_SCRIPT_FETCH_RE.test(combined)
        || SW_SCRIPT_FETCH_RE.test(combined)
        || STALE_CSS_PRELOAD_RE.test(combined)
        || STALE_DYNAMIC_IMPORT_RE.test(combined)
    )
}
